import React from 'react';
import { useTranslation } from 'react-i18next';
import { CHILD_READING_BOOKS } from '../../services/readingBook/graphql';
import { useQuery } from '@apollo/react-hooks';
import StudentContent from './studentContent';

const Child = ({ id }) => {
    const { t } = useTranslation();

    const {
        data: readingBooks,
        error,
        loading,
    } = useQuery(CHILD_READING_BOOKS, {
        variables: {
            childId: id,
        },
        fetchPolicy: 'network-only'
    });

    return (
        <>
            {error && <p>{error.message}</p>}
            {loading && <p>{t('loading')}</p>}
            {readingBooks && (
                <StudentContent id={id} student={readingBooks.child.student} />
            )}
        </>
    );
};

export default Child;
